import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  NotifContainer,
  NotifContent,
  NotifCloseButton,
  NotifTitle,
  NotifParagraph,
  NotifStepList
} from './HomeStyles';

const NotificationHome = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  const steps = [
    t('home_notification_step_1'),
    t('home_notification_step_2'),
    t('home_notification_step_3'),
    t('home_notification_step_4'),
    t('home_notification_step_5')
  ];

  return (
    <NotifContainer>
      <NotifContent>
        <NotifCloseButton onClick={() => setVisible(false)}>×</NotifCloseButton>
        <NotifTitle>{t('home_notification_title')}</NotifTitle>
        <NotifParagraph>{t('home_notification_city_text')}</NotifParagraph>
        <NotifParagraph>{t('home_notification_steps_intro')}</NotifParagraph>
        <NotifStepList>
          {steps.map((step, index) => (
            <li key={index}>{step}</li>
          ))}
        </NotifStepList>
      </NotifContent>
    </NotifContainer>
  );
};

export default NotificationHome;
